export default __webpack_public_path__ + "static/media/phone.ceb846ba.svg";